<template>
  <div class="mine-content">
    <div class="mine-header"><span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png"/></span>{{currentTitle}}</div>
    <div class="second-pard" :style="currentTitle=='Signature'?'height:4rem;':''">
      <div class="phonenumberbox" :style="currentTitle=='Signature'?'height:2rem;':''">
        <span>{{currentTitle}}</span>
        <textarea v-if="currentTitle=='Signature'" class="input-text" style="height:2rem;" v-model="fieldValue" maxlength="60" @keyup.enter="saveInfo" placeholder="Enter the content here"></textarea>
        <input v-else v-model="fieldValue" type="text" @keyup.enter="saveInfo" placeholder="Enter the content here" />
        <div class="clearbtn" @click="clearbtn">
          <img src="@/assets/images/base/close.png" />
        </div>
      </div>
      <div class="buttonbox">
        <button class="appbtn" v-show="!showloding" @click="submitbtn()">Save</button>
        <button class="appbtn" v-show="showloding">Save</button>
      </div>
    </div>
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical/>
</div>
</template>
<script>
      /*global mui*/
    import Vue from "vue";
    import { Loading } from "vant";
    Vue.use(Loading);
    export default {
      data() {
        return {
          showloding: false,
          userInfo:this.util.user,
          currentTitle:"",
          fieldKey:"",
          fieldValue:"",
        };
      },
      methods:{
        clearbtn() {
          this.fieldValue = "";
        },
        submitbtn() {
          let re = /[^\d]/g;
          // eslint-disable-next-line no-useless-escape
          let pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
          if (this.fieldValue.length < 1) {
            mui.alert("Content cannot be empty");
          } else if (this.fieldKey == "login_name" && this.fieldValue.length > 15) {
            mui.alert("User name cannot exceed 15 characters");
          } else if (this.fieldKey == "nick_name" && this.fieldValue.length > 15) {
            mui.alert("Nickname cannot be longer than 15 characters");
          } else if (this.fieldKey == "remark" && this.fieldValue.length > 60) {
            mui.alert("Individual signature cannot exceed 60 characters");
          } else if (!this.showloding) {
            this.saveInfo();
          }
          // else if (this.fieldKey == "email" && !pattern.test(this.fieldValue)) {
          //   mui.alert("Incorrect mailbox format");
          // } else if (this.fieldKey == "email" && this.fieldValue.length > 50) {
          //   mui.alert("Mailbox is within 50 characters");
          // }
          // else if (this.fieldKey == "phone" && re.test(this.fieldValue)) {
          //   mui.alert("UserName can only be numbers");
          // } else if (this.fieldKey == "phone" && this.fieldValue.length > 15) {
          //   mui.alert("UserName cannot exceed 15 characters");
          // } 
        },
        saveInfo(){
          let params = {fieldKey:this.fieldKey,fieldValue:this.fieldValue};
          if(this.fieldValue==''){
            mui.toast(this.currentTitle+" cannot be empty");
            return false;
          }
          this.util.setDnValueUser(params);
          this.axios.post(this.api.api_updateUserInfo, this.util.encodeSearchParams(params)).then(res => {
              this.showloding = false;
              if (res.data.code == 0) {
                this.userInfo[this.fieldKey] = this.fieldValue;
                mui.toast("Modification succeeded");
                window.history.back();
              } else {
                mui.toast(res.data.message);
              }
            })
            .catch(() => {
              this.showloding = false;
              mui.toast("Modification failed");
            });
        },
      },
      activated(){
        if (!this.util.isLogin()) this.util.topage('login');
        this.fieldKey = this.$route.params.fieldKey;
        switch(this.fieldKey){
          case "nick_name": {
            this.currentTitle = "Nickname";
            break;
          }
          case "phone": {
            this.currentTitle = "UserName";
            break;
          }
          case "email":{
            this.currentTitle = "Email";
            break;
          }
          case "remark":{
            this.currentTitle = "Signature";
            break;
          }
        }
        this.util.refreshUserInfo((res)=>{
          this.userInfo = res;
          this.fieldValue = this.userInfo[this.fieldKey];
        });
      }
    };
    </script>
    <style lang="scss" scoped>
    .mine-content{
      font-size: 0.34rem;
      background: rgb(235, 235, 235);
      color:rgb(103, 103, 103);
      width: 100%;
      height: 100%;
      .mine-header{
        color:black;
        font-weight: bold;
        height: 1.2rem;
        display: grid;
        grid-template-columns: 30% 1fr 30%;
        align-items: center;
        text-align: center;
        .back{
          cursor: pointer;
          img{
            display: block;
            margin-left: 10%;
            width: 0.5rem;
            transform: rotate(180deg);
          }
        }
      }
      .second-pard {
        height: 3rem;
        width: 96%;
        background: white;
        margin: auto;
        padding: 10px 10px;
        border-radius: 10px/10px;
        font-size: 0.34rem;
        .phonenumberbox {
          width: 100%;
          position: relative;
          height: 1rem;
          display: flex;
          align-items: center;
          margin-top: 0.2rem;
          margin-left: 0.1rem;
          input ,.input-text{
            margin-left: 0.5rem;
            width:64%;
          }
          .clearbtn {
            width: 0.6rem;
            height: 0.6rem;
            border-radius: 50%;
            background: #f8f0e6;
            position: absolute;
            top: 50%;
            right: 0.2rem;
            transform: translateY(-50%);
            display: flex;
            justify-content: space-around;
            align-items: center;
            img {
              width: 0.56rem;
              height: 0.56rem;
            }
          }
        }
        .buttonbox {
          display: flex;
          justify-content: center;
          padding-top: 0.14rem;
          margin-bottom: 1.3rem;
          button {
            border-radius: 4px;
            width: 96%;
            height: 1rem;
            font-size: 0.34rem;
            background: #628808;
            color: white;
          }
          button:hover {
            background: #628808;
          }
        }
      }
    }
    </style>  